<!-- @format -->

<template>
  <div class="event-wrapper-main">
    <Breadcrumb><slot name="action-buttons"></slot></Breadcrumb>

    <div id="event_wrapper">
      <EventMenu />
      <div class="page-content">
        <div class="content-wrapper">
          <vue-page-transition name="fade">
            <router-view></router-view>
          </vue-page-transition>
        </div>
      </div>
    </div>

    <div class="navbar navbar-expand-lg navbar-light sticky-footer socialhub-wrapper">
      <div class="socialhub-switch">
        <div class="socialhub-switch-inner" @click="openDrawerOrDialog">
          <i class="fa fa-spinner fa-spin" v-if="loading == 'createPost'"></i>
          <i class="fa" v-else :class="drawer ? 'fa-pen' : 'fa-heart'"></i>
          <span>{{ drawer ? $t("components.eventWrapper.createPost") : $t("components.eventWrapper.socialHub") }}</span>
        </div>
        <div v-if="drawer" class="socialhub-switch-close" @click="drawer = false">
          <i class="fa fa-times"></i>
        </div>
      </div>
    </div>

    <el-dialog :title="$t('components.eventWrapper.createPost')" :visible.sync="createPostModal" :close-on-click-modal="false" class="large" center append-to-body destroy-on-close>
      <CreatePost :id="updatePostId" v-if="createPostModal" @closeDialog="createPostModal = false" />
    </el-dialog>

    <el-drawer :visible.sync="drawer" :direction="direction" size="350px" :withHeader="false" :wrapperClosable="false" :modal="true" :destroy-on-close="true" :close-on-press-escape="false" :custom-class="'social-drawer'">
      <SocialHub v-if="drawer" />
    </el-drawer>
    <el-dialog :visible.sync="excelDialog" class="medium" :title="$t('components.eventWrapper.export')" :close-on-click-modal="false" center modal-append-to-body destroy-on-close>
      <ExcellExport @closeMe="excelDialog = false" :payload="excelDialogPayload" v-if="excelDialog" />
    </el-dialog>
    <el-dialog :visible.sync="importDialog" class="medium" :title="$t('components.eventWrapper.import')" :close-on-click-modal="false" center modal-append-to-body destroy-on-close>
      <ExcelImport @closeDialog="importDialog = false" v-if="importDialog" :type="importExcellType" />
    </el-dialog>
    <el-dialog :visible.sync="sendVoucherDialog" :title="$t('components.eventWrapper.sendVoucher')" class="medium" :close-on-click-modal="false" center modal-append-to-body destroy-on-close>
      <SendVoucher v-if="sendVoucherDialog" :payload="sendVoucherPayload" @closeMe="sendVoucherDialog = false" />
    </el-dialog>
    <el-dialog :visible.sync="sendCertificateDialog" :title="$t('generic.sendCertificate')" class="medium" :close-on-click-modal="false" center modal-append-to-body destroy-on-close>
      <SendCertificate v-if="sendCertificateDialog" :payload="sendCertificatePayload" @closeMe="sendCertificateDialog = false" />
    </el-dialog>
    <el-dialog :visible.sync="openPaymentDialog" :title="$t('components.eventWrapper.paymentDetail')" class="large" :close-on-click-modal="false" center modal-append-to-body destroy-on-close>
      <SummaryComponent v-if="openPaymentDialog" :participant="payment.participant" :paymentInfo="payment.payment" @closeDialog="openPaymentDialog = false" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="participantDetailModal" :title="$t('components.eventWrapper.participantDetails')" class="large" center :destroy-on-close="true">
      <div id="participant-details-modal" class="custom-modal" v-if="participantDetailModal">
        <div class="modal-body">
          <ParticipantDetails :id="participantID" @closeDialog="participantDetailModal = false" />
        </div>
        <div class="modal-footer">
          <div class="left-buttons">
            <el-button @click="participantDetailModal = false">{{ $t("components.eventWrapper.close") }}</el-button>
          </div>
          <div class="right-buttons"></div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="upgradeModal" :title="$t('components.dashboard.content.upgrade')" class="large upgrade-dialog" center :destroy-on-close="true">
      <UpgradeDialog v-if="upgradeModal" @closeDialog="upgradeModal = false" />
    </el-dialog>
  </div>
</template>

<script>
import ParticipantDetails from "@/components/participants/ParticipantDetails.vue";
import SendVoucher from "@/components/participants/SendVoucher.vue";
import SendCertificate from "@/components/participants/SendCertificate.vue";
import ExcellExport from "@/components/ExcellExport.vue";
import SummaryComponent from "@/components/participants/SummaryComponent.vue";
import ExcelImport from "@/components/ExcelImport.vue";
import EventMenu from "@/components/EventMenu";
import CreatePost from "@/components/socialhub/CreatePost";
import SocialHub from "@/components/socialhub/SocialHub";
import UpgradeDialog from "@/components/upgrade/UpgradeDialog";
import EventBus from "@/helpers/event-bus.js";

export default {
  name: "EventWrapper",
  components: { EventMenu, UpgradeDialog, CreatePost, SocialHub, ExcellExport, SendVoucher, ExcelImport, SummaryComponent, ParticipantDetails, SendCertificate },
  data() {
    return {
      upgradeModal: false,
      importExcellType: null,
      participantDetailModal: false,
      participantID: null,
      openPaymentDialog: false,
      payment: {
        payment: null,
        participant: null
      },
      sendVoucherPayload: {
        certificateSchemeId: null,
        queryJson: null,
        participantIds: ["string"]
      },
      sendCertificatePayload: {
        type: null,
        automatedMessageId: null,
        queryJson: null,
        participantIds: []
      },
      sendCertificateDialog: false,
      sendVoucherDialog: false,
      bulkDeleteDialog: false,
      excelDialogPayload: {
        type: null,
        itemId: null,
        queryJson: null
      },
      excelDialog: false,
      createPostModal: false,
      drawer: false,
      updatePostId: null,
      loading: false,
      timeout: null,
      direction: "rtl",
      socialtab: 1,
      importDialog: false
    };
  },

  methods: {
    openDrawerOrDialog() {
      if (this.drawer) {
        this.createPost();
      } else {
        this.drawer = true;
      }
    },
    async createPost() {
      this.loading = "createPost";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("socialHubAddOrUpdate", {
          type: 0,
          isDraft: true,
          isAnnouncement: true
        });
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.updatePostId = res.data.data.item.id;
          this.createPostModal = true;
          setTimeout(() => {
            this.$store.commit("setDraftInfinite");
          }, 500);
        }
        this.loading = false;
      }, 500);
    }
  },
  mounted() {
    EventBus.$on("exportXlsx", (type, itemId, filter) => {
      this.excelDialogPayload.type = type;
      this.excelDialogPayload.itemId = itemId;
      this.excelDialogPayload.queryJson = filter;
      this.excelDialog = !this.excelDialog;
    });
    EventBus.$on("importExcell", type => {
      this.importExcellType = type;
      this.importDialog = true;
    });
    EventBus.$on("bulkDelete", (list, json) => {
      console.log("bulkDelete");
      // this.sendCertificatePayload.participantIds = list;
      // this.sendCertificatePayload.queryJson = json;
      // this.sendCertificateDialog = !this.sendCertificateDialog;
    });
    EventBus.$on("upgradeModal", () => {
      this.upgradeModal = true;
    });
    EventBus.$on("sendCertificate", (list, json) => {
      console.log("sendCertificate");
      this.sendCertificatePayload.participantIds = list;
      this.sendCertificatePayload.queryJson = json;
      this.sendCertificateDialog = !this.sendCertificateDialog;
    });
    EventBus.$on("sendVoucher", (list, json) => {
      console.log("sendVoucher");
      this.sendVoucherPayload.participantIds = list;
      this.sendVoucherPayload.queryJson = json;
      this.sendVoucherDialog = !this.sendVoucherDialog;
    });
    EventBus.$on("editPost", payload => {
      this.updatePostId = payload;
      this.createPostModal = true;
    });
    EventBus.$on("openPaymentDetail", (payment, participant) => {
      this.payment.payment = payment;
      this.payment.participant = participant;
      this.openPaymentDialog = true;
    });
    EventBus.$on("openParticipantDetail", id => {
      this.participantID = id;
      this.participantDetailModal = !this.participantDetailModal;
    });
  },
  watch: {
    drawer: function(newVal) {
      if (!newVal) {
        this.createPostModal = false;
        this.updatePostId = null;
      }
    }
  }
};
</script>

<style scoped lang="less">
.event-wrapper-main {
  .socialhub-wrapper {
    background-color: unset !important;
    box-shadow: unset !important;
    border: unset;
    justify-content: flex-end !important;
    pointer-events: none;
    z-index: 3000;
    padding: 10px 18px !important;

    .socialhub-switch {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;

      .socialhub-switch-inner {
        color: white;
        background: #06658c;
        padding: 6px 12px;
        border-radius: 25px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer !important;
        pointer-events: all;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);

        i {
          margin-right: 8px;
        }
      }
    }

    .socialhub-switch-close {
      background: #ff6565;
      font-weight: 500;
      border-radius: 50%;
      width: 35px;
      height: 35px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      cursor: pointer !important;
      pointer-events: all;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);

      i {
        font-size: 16px;
        color: white;
        margin: 0px;
        padding: 3px 3px;
      }
    }
  }
}
.fa-spin {
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EventWrapper.vue